export enum AdlSortMethod {
  Positions = 'Positions',
  PnL = 'PnL',
  EntryPrice = 'Entry Price',
  MarkPrice = 'Mark Price',
  Size = 'Size',
  Bonus = 'Bonus',
  Action = 'Action',
}
